import type { ReactNode } from "react";

/** Page title row: title on the left, actions on the right, an optional one-line explanation. */
export function PageHeader({ title, sub, actions, children }: { title: ReactNode; sub?: ReactNode; actions?: ReactNode; children?: ReactNode }) {
  return (
    <div className="mb-3 space-y-2">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
        <h1 className="text-lg font-semibold">{title}</h1>
        {sub && <span className="text-sm text-[var(--color-muted-foreground)]">{sub}</span>}
        {actions && <div className="ml-auto flex flex-wrap items-center gap-1.5">{actions}</div>}
      </div>
      {children}
    </div>
  );
}

export function Empty({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="px-4 py-8 text-center">
      <p className="text-sm font-medium">{title}</p>
      {children && <div className="mt-1 text-sm text-[var(--color-muted-foreground)]">{children}</div>}
    </div>
  );
}
